import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import router from './router'
const VueScrollTo = require('vue-scrollto');
import _ from 'lodash';
import { TimelineLite, CSSPlugin } from "gsap/all";
// const TweenLite require('gsap/TweenLite');
Vue.config.silent
Vue.config.productionTip = false
Vue.use(VueScrollTo, {offset: -115});
Vue.use(VueAxios, axios);
Vue.prototype.CSSPlugin = CSSPlugin;
Vue.prototype.TimelineLite = TimelineLite;
Vue.prototype._ = _;

Vue.filter('sanitize', function (word) {
  let payload = _.kebabCase(word);
  return payload
});

// Vue.use(VueScrollTo)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
